import { inject, Injectable, Injector } from '@angular/core';
import { BaseService } from '../../base/base.service';
import { IRoleModel } from '../../model/user/role.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class RoleService extends BaseService<IRoleModel> {
    constructor() {
        super(inject(Injector), 'role');
    }

    public findAllRoles(): Observable<IRoleModel[]> {
        return this.httpClient.get<IRoleModel[]>(`${this.environment.APP.VC_USER_BASE_URL}/${this.serviceBaseUrl}`);
    }

    public getRolesHierarchy(): Observable<IRoleModel[]> {
        return this.httpClient.get<IRoleModel[]>(
            `${this.environment.APP.VC_USER_BASE_URL}/${this.serviceBaseUrl}/descendants`
        );
    }

    public searchRoles(): Observable<IRoleModel[]> {
        return this.httpClient.get<IRoleModel[]>(`${this.environment.APP.VC_USER_BASE_URL}/${this.serviceBaseUrl}`);
    }

    public updateRole(model: IRoleModel): Observable<IRoleModel> {
        return this.httpClient.post<IRoleModel>(
            `${this.environment.APP.VC_USER_BASE_URL}/${this.serviceBaseUrl}`,
            model
        );
    }

    public deleteRole(name: string): Observable<void> {
        return this.httpClient.delete<void>(`${this.environment.APP.VC_USER_BASE_URL}/${this.serviceBaseUrl}/${name}`);
    }

    public getRoleByName(name: string): Observable<IRoleModel> {
        return this.httpClient.get<IRoleModel>(
            `${this.environment.APP.VC_USER_BASE_URL}/${this.serviceBaseUrl}/${name}`
        );
    }

    public getRoleDescendants(name: string): Observable<IRoleModel[]> {
        return this.httpClient.get<IRoleModel[]>(
            `${this.environment.APP.VC_USER_BASE_URL}/${this.serviceBaseUrl}/${name}/descendants`
        );
    }
}
